import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M35.6 23.7H19.1v-2.5h16.5c3.9 0 7-3.1 7-7s-3.1-7-7-7h-3.4V4.8h3.4c5.2 0 9.5 4.3 9.5 9.5s-4.2 9.4-9.5 9.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M17.7 40.2H9.5C4.3 40.2 0 36 0 30.8s4.3-9.5 9.5-9.5h.8v2.5h-.8c-3.9 0-7 3.1-7 7s3.1 7 7 7h8.2v2.4z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "45 39 38.5 35.2 38.5 37.7 27.2 37.7 27.2 40.2 38.5 40.2 38.5 42.7"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "17.8 6 11.3 2.3 11.3 4.8 0 4.8 0 7.3 11.3 7.3 11.3 9.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M28 10.5L20.7 6 28 1.5 35.4 6 28 10.5zM25.5 6L28 7.5 30.6 6l-2.5-1.5L25.5 6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 43.5L15.2 39l7.3-4.5 7.3 4.5-7.3 4.5zM20 39l2.5 1.5L25 39l-2.5-1.5L20 39z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M15.4 26.9l-7.3-4.5 7.3-4.5 7.3 4.5-7.3 4.5zm-2.5-4.4l2.5 1.5 2.5-1.5-2.5-1.5-2.5 1.5z"
		})
	]
});
export default SvgIcon;
